"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateZip = exports.validatePostal = void 0;
const ca_postal_codes_1 = __importDefault(require("./ca-postal-codes"));
exports.validatePostal = ca_postal_codes_1.default;
const us_zip_codes_1 = __importDefault(require("./us-zip-codes"));
exports.validateZip = us_zip_codes_1.default;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvemlwLXBvc3RhbC1jb2Rlcy9pbmRleC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7QUFBQSx3RUFBaUU7QUFHeEQseUJBSEYseUJBQWMsQ0FHRTtBQUZ2QixrRUFBd0Q7QUFFL0Isc0JBRmxCLHNCQUFXLENBRWtCIn0=